import {setTrackerParameterToEdit} from 'actions/index.js';

export const TRACKER_PARAMETERS = ["Transpose", "Duration", "Chop", "Slice"];

const getParameter = (sequencerEngine) => {
    return sequencerEngine.state.mix.trackerParameterToEdit;
};

const getNewParameter = (sequencerEngine, parameter, off=0) => {
    let stepData = getStepData(sequencerEngine, 0, off);
    return stepData.parameters.find(
        p => p.name === parameter.name);
}

export const mixArrowDown = (sequencerEngine) => {
    let parameter = getParameter(sequencerEngine);
    if (parameter) {
        return;
    }
    let {cursor, resolution} = sequencerEngine;
    let step = cursor.getStep(resolution);
    let track = sequencerEngine.getSelectedTrack();
    step++;
    if (step >= track.pattern.length(resolution)) {
        step = 0;
    }
    cursor.setStep(step, resolution);
};

export const mixArrowUp = (sequencerEngine) => {
    let parameter = getParameter(sequencerEngine);
    if (parameter) {
        return;
    }
    let {cursor, resolution} = sequencerEngine;
    let step = cursor.getStep(resolution);
    let track = sequencerEngine.getSelectedTrack();
    step--;
    if (step < 0) {
        step = track.pattern.length(resolution) + step;
    }
    cursor.setStep(step, resolution);
};



export const mixArrowLeft = (sequencerEngine) => {
    let parameter = getParameter(sequencerEngine);
    if (!parameter) {
        sequencerEngine.up();
        return;
    }
    let stepData = getStepData(sequencerEngine);
    let _index = TRACKER_PARAMETERS.indexOf(parameter.name);
    if (_index === 0) {
        sequencerEngine.up();
        let stepData = getStepData(sequencerEngine);
        if (stepData) {
            sequencerEngine.dispatch(
                setTrackerParameterToEdit(
                    stepData.parameters.find(p => p.name === TRACKER_PARAMETERS[3])));
        } else {
            sequencerEngine.dispatch(
                setTrackerParameterToEdit(undefined));
        }
        return;
    }
    let index = (_index - 1 + TRACKER_PARAMETERS.length) % TRACKER_PARAMETERS.length;
    let _parameter = stepData.parameters.find(
        p => p.name === TRACKER_PARAMETERS[index]);
    sequencerEngine.dispatch(
        setTrackerParameterToEdit(
            _parameter));
};

export const mixArrowRight = (sequencerEngine) => {
    let parameter = getParameter(sequencerEngine);
    if (!parameter) {
        sequencerEngine.down();
        return;
    }
    let stepData = getStepData(sequencerEngine);
    let index = (TRACKER_PARAMETERS.indexOf(parameter.name) + 1) % TRACKER_PARAMETERS.length;
    let _parameter = stepData.parameters.find(
        p => p.name === TRACKER_PARAMETERS[index]);
    sequencerEngine.dispatch(
        setTrackerParameterToEdit(
            _parameter));
};

const getStepData = (sequencerEngine, trackOffset=0, stepOffset=0) => {
    let tracks = sequencerEngine.tracks;
    let {track, step} = sequencerEngine.cursor;
    let selectedTrack = tracks[(track + trackOffset) % tracks.length];
    let stepBucket = selectedTrack.pattern.stepBuckets[(step + stepOffset) % selectedTrack.length];
    return stepBucket.getAllOnSteps()[0]; 
};
